module.exports = {
	"pagination": {
		"ListQueues": {
			"result_key": "QueueUrls"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/sqs-2012-11-05.paginators.json
// module id = 697
// module chunks = 0